<template>
	<ActivityBadgeLayout class="type-change-activity-badge">
		<FontAwesomeIcon :icon="[ `fas`, `shapes` ]" />
	</ActivityBadgeLayout>
</template>

<script>
import ActivityBadgeLayout from "./ActivityBadgeLayout";
export default {
	name: "TypeChangeActivityBadge",
	components: {
		ActivityBadgeLayout,
	},
};
</script>

<style lang="scss" scoped>
$badgeColor: $color1-500;
$badgeBackgroundColor: $color1-100;

.type-change-activity-badge {
	background-color: $badgeBackgroundColor;

	* {
		color: $badgeColor;
	}
}
</style>
